import { useContext } from 'react';
import PendingRequestsContext from 'src/contexts/PendingRequestsContext';

const usePendingRequests = () => useContext(PendingRequestsContext);

export default usePendingRequests;
